/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import Icon from "../common/Icon/Icon";
import styles from "./Toast.module.css";
import Button from "../common/Buttons/Button/Button";

enum StatusColor {
    error = "text-plum-500",
    warning = "text-mustard-300",
    success = "text-mint-300",
    info = "text-velvet-500",
}

enum ContainerColor {
    error = "before:bg-plum-500 bg-plum-900",
    warning = "before:bg-mustard-300 bg-mustard-900",
    success = "before:bg-mint-300 bg-mint-800",
    info = "before:bg-velvet-500 bg-velvet-900",
}

enum StatusIcons {
    error = "warning",
    warning = "warning",
    success = "success",
    info = "info",
}

interface Props {
    id: string;
    status: "error" | "warning" | "success" | "info";
    title: string;
    href?: string;
    removeToast?: (id: string) => void;
}

const DEFAULT_TOAST_DELAY = 5000;

const Toast = ({ id, status, title, href, removeToast }: Props) => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(false); // we need to set show to false to trigger the transition then we remove it on afterLeave
        }, DEFAULT_TOAST_DELAY);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    const handleCloseClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShow(false); // we need to set show to false to trigger the transition then we remove it on afterLeave
    };

    const handleAfterLeave = () => {
        if (removeToast) removeToast(id);
    };

    return (
        <Transition
            appear
            show={show}
            enter="transition-opacity duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={handleAfterLeave}
        >
            <div
                className={`${ContainerColor[status]} ${styles.toast}`}
                style={{ "--duration": `${DEFAULT_TOAST_DELAY}ms` } as React.CSSProperties}
            >
                <div className="flex flex-row gap-0.5 items-center">
                    <Icon icon={StatusIcons[status]} className={StatusColor[status]} width={18} height={18} />
                    <div className="space-y-0.25 flex-grow">
                        <output className="flex justify-between">
                            <h5 className="type-label text-midnight-500">{title}</h5>
                        </output>
                    </div>
                </div>
                <div className="relative z-10">
                    <Button onClick={handleCloseClick} variant="none">
                        <Icon icon="cross" />
                    </Button>
                </div>
                <a href={href} title="Click to view notification" className="absolute inset-0 w-full h-full text-transparent z-0">
                    Click to view notification
                </a>
            </div>
            {/* Your content goes here */}
        </Transition>
    );
};

export default Toast;
